import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8c9e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hashtag"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hashtags && _ctx.hashtags.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.hashtags.join(', ')), 1))
    : _createCommentVNode("", true)
}